import React from 'react'
import { injectIntl } from 'react-intl'
import { Body } from 'shared-global-ec-uikit/components/dist/react/esm/components/body'
import { Display } from 'shared-global-ec-uikit/components/dist/react/esm'
import Parser from 'html-react-parser'

const StoreAnnouncements = (props: any) => {
  return (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
        className="fr-ec-mb-spacing-04"
      >
        {props.intl.formatMessage({ id: `text_store_announcements` })}
      </Display>
      <Body color="primary-dark" element="p" variant="standard">
        {Parser(props.announcement)}
      </Body>
      <Body color="primary-dark" element="p" variant="standard">
        {props.paymentComment}
      </Body>
    </>
  )
}

export default injectIntl(StoreAnnouncements)
